(function () {
  var t = document.getElementById('navToggle'), n = document.getElementById('mainNav');
  if (t && n) t.addEventListener('click', function () {
    var abierto = n.classList.toggle('abierto');
    t.setAttribute('aria-expanded', abierto ? 'true' : 'false');
  });
  var principal = document.getElementById('mediaPrincipal');
  document.querySelectorAll('.thumb').forEach(function (b) {
    b.addEventListener('click', function () { if (principal) principal.src = b.dataset.src; });
  });
  var json = document.getElementById('variantesJson');
  if (json) {
    var variantes = JSON.parse(json.textContent), sels = document.querySelectorAll('.variantes__sel');
    var fmt = function (c) { return '$ ' + (c / 100).toLocaleString('es-AR', { minimumFractionDigits: 2 }); };
    var act = function () {
      var opts = Array.prototype.map.call(sels, function (s) { return s.value; });
      var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      if (!v) return;
      document.getElementById('variantId').value = v.id;
      var p = document.getElementById('precio'); if (p) p.innerHTML = '<span class="precio__ahora">' + fmt(v.price) + '</span>';
      var btn = document.querySelector('#product-form .btn');
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? (btn.dataset.txt + ' →') : 'Agotado'; }
    };
    sels.forEach(function (s) { s.addEventListener('change', act); });
  }
})();
